import { NotificationSuccessIcon } from '@tableau/icons/NotificationSuccessIcon';
import { CloseButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { uploadedFileTextStyle, uploadedFileWidgetBaseStyle } from '../styles/CustomDomainStyles';

export interface UploadedFileViewProps extends React.HTMLProps<HTMLElement> {
    fileName: string;
    handleClose(): void;
    tbTestId: string;
  }

export class UploadedFileView extends React.Component<UploadedFileViewProps, {}> {

    public constructor(props: UploadedFileViewProps) {
        super(props);
      }

    public render(): JSX.Element {
        return <>
            <div style={uploadedFileWidgetBaseStyle}>
                <NotificationSuccessIcon size={18} alt="File Uploaded" style={{marginLeft: 5}}/>
                <div style={uploadedFileTextStyle}>
                    {this.props.fileName}
                </div>
                <CloseButtonWidget onClick={this.props.handleClose} style={{position: 'absolute', right: 5}} data-tb-test-id={this.props.tbTestId}/>
            </div>
        </>;

    }
}